<div class="chartHistoryScores">
  <div class="col col1">
    <div class="title-area">
      <div class="">
        <h4 class="title">
          Score History
        </h4>
      </div>
      <div class="timelines">
        <button mat-button class="item active">Overall</button>
      </div>
    </div>
    <div class="chart-container">
      <apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
        [title]="chartOptions.title"></apx-chart>
    </div>
  </div>
  <div class="col col2 content">
    <h3 class="info-title">
      Oct-2025 : 872 Credit Score
    </h3>
    <ul class="notes">
      <li *ngFor="let reason of reasonsList">
        {{ reason }}
      </li>
    </ul>
  </div>
</div>